module.exports = __webpack_public_path__ + "static/img/头盔.f4823cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/头盔.png
// module id = Hqr5
// module chunks = 192